import { Command } from './Command';
import { InsuredPatientCommandParams } from './InsuredPatientCommandParams';

export type VerifyPatientInteractionsParams = InsuredPatientCommandParams & {
	dateFrom: string;
	dateTo: string;
	medicamentCode: string[];
};

export const VerifyPatientInteractions = (
	params: VerifyPatientInteractionsParams,
): Command => {
	return {
		operation: 'OverInterakciePacienta_v6',
		params,
	};
};
